// @flow
import React, { useContext } from 'react';
import { useGlobalDiscountProvidedByStatus } from '@src/custom-hooks/useGlobalDiscountProvidedByStatus';
import { If } from '@presentational/If';
import { Spacer } from '@presentational/spacing/Spacer';

import { SystemAdminNonAdminStatusLabel } from '../common/SystemAdminNonAdminStatusLabel';
import { GLOBAL_DISCOUNT_APPLIED_BACKEND_NAME } from '../../constants';
import { TextField } from '../../formik-utils/FormFields';
import { getIfCustomerViewIsEnabled } from '../../common-utils/utils';
import { ESTIMATE_COMMIT_DETAILS_CONFIG_MAP } from '../../configuration/estimate-commit-details';
import { TEXT_NUMBER_INPUT_TYPE } from '../../formik-utils/consts';
import { EstimateContext } from '../../contexts/EstimateContext';

export const DiscountAppliedContainer = () => {
  const estimateData = useContext(EstimateContext);
  const { isGlobalDiscountSystemGenerated, isGlobalDiscountGivenByAdminUser, shouldShowGDTag } =
    useGlobalDiscountProvidedByStatus();

  const discountAppliedConfig = ESTIMATE_COMMIT_DETAILS_CONFIG_MAP.get(
    GLOBAL_DISCOUNT_APPLIED_BACKEND_NAME
  );
  const { displayName, icon, backendFieldName } = discountAppliedConfig;
  return (
    <TextField
      disabled={getIfCustomerViewIsEnabled(estimateData?.inputs)}
      fieldDisplayName={
        <>
          {displayName}
          <If test={shouldShowGDTag}>
            <Spacer x={10} />
            <SystemAdminNonAdminStatusLabel
              isAddedByAdmin={isGlobalDiscountGivenByAdminUser}
              isSystemGenerated={isGlobalDiscountSystemGenerated}
              ribbon={false}
            />
          </If>
        </>
      }
      fieldName={backendFieldName}
      icon={icon}
      type={TEXT_NUMBER_INPUT_TYPE}
    />
  );
};
